import { useState, useCallback } from "react";
import { ActiveFilterOption, YearOption } from "../types";
import { UseAccountFiltersReturn, UseAccountFiltersParams } from "./types";

export const useAccountFilters = ({
  defaultYear,
  defaultActive,
}: UseAccountFiltersParams): UseAccountFiltersReturn => {
  const [yearSelected, setYearSelected] = useState<YearOption>(defaultYear);
  const [activeOnly, setActiveOnly] =
    useState<ActiveFilterOption>(defaultActive);

  const handleYearChange = useCallback((option: YearOption) => {
    setYearSelected(option);
  }, []);

  const handleActiveChange = useCallback((option: ActiveFilterOption) => {
    setActiveOnly(option);
  }, []);

  return {
    yearSelected,
    activeOnly,
    handleYearChange,
    handleActiveChange,
  };
};
